import styled from 'styled-components';

const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #223a5e;
`;

export default Title;
